<template>
    <div class="block page20 f-r f-c">
        <PageHeader
          :title="moduleData['3_20_1_1']"
          :sub-title="moduleData['3_20_1_1_en']"
          :page-logo="reportCustomization.pageLogo"
        />
        <PageTips :page-num="pageNum"/>
        <div class="page20-body f-r j-b">
            <div class="page20-body-left">
              <div class="page20-body-header f-r j-b a-c">
                  <div class="page20-body-header-left">{{ PAGE_TEXT[commonLang].tourismProjects }} {{ totalSize }} {{ PAGE_TEXT[commonLang].unitStore }}</div>
              </div>
              <TableNav width="900px">
                  <template v-slot:title> {{ PAGE_TEXT[commonLang].nearestProjects }} </template>
              </TableNav>
              <PTable :col-data="colData" :row-data="rowData" style="min-height: 420px">
                <Empty :text="PAGE_TEXT[commonLang].noTourismCoverage" v-if="!rowData.length"/>
              </PTable>
              <div v-if="reportCustomization.showWater" class="page16-map-tips">
                <div class="page-tips2" style="padding-bottom: 27px;margin: 23px 0 0">{{ PAGE_TEXT[commonLang].moreInfo }}</div>
              </div>
                <div class="page20-body-header f-r j-b a-c">
                    <div class="page20-body-header-left">{{ PAGE_TEXT[commonLang].projectDistribution }}</div>
                </div>
                <BarChart
                  style="height: 220px; width: 100%"
                  color="#4B86FF"
                  :bar-width="50"
                  :x-data="rowData.map(v => v.name)"
                  :y-data="rowData.map(v => v.value)"
                >
                  <Empty :text="PAGE_TEXT[commonLang].noTourismCoverage" v-if="!rowData.length"/>
                </BarChart>
            </div>
            <div class="page20-body-right">
                <div class="page20-body-right f-c">
                    <div class="page15-map" id="page15Map">
                          <Empty :text="PAGE_TEXT[commonLang].noTourismCoverage" v-if="!rowData.length"/>
                    </div>
                    <div class="page15-map-legend f-r a-c f-w">
                      <div
                        class="page15-map-legend-item f-r a-c"
                        v-for="(item, index) in typeList"
                        :key="index"
                      >
                        <div
                          class="page15-map-legend-point point1"
                          :style="{ background: item.color }"
                        ></div>
                        {{ item.name }}
                      </div>
                    </div>
                    <div v-if="reportCustomization.showDataSource" class="page15-map-tips">
                      {{ PAGE_TEXT[commonLang].dataSource }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import TableNav from "./components/TableNav";
import PTable from "./components/PTable";
import BarChart from "./components/BarChart3";
import Empty from "./components/Empty";
import AMapLoader from "@amap/amap-jsapi-loader";
import { AMAP_KEY } from "@/constants/common";
import { shallowRef } from "@vue/reactivity";

import { getMapDelayByMarkerCount } from '@/utils'
import {
  drawMapKeepAlive,
} from '@/api/apiv2'

import { computed, onMounted, ref } from "vue";
import { mapAddCircle, addMapCenter, mapAddPolygonV2 } from "@/utils/pdf";
import { useStore } from "vuex";

const props = defineProps({
      pageNum: String,
      cityInfo: {
        type: Object,
        default: () => {
            return {};
        },
      },
      catData: {
        type: Array,
        default: () => [],
      },
      moduleData: {
        type: Object,
        default: () => {
          return {};
        },
      },
      // poi改造后数据
      poiData: {
        type: Object,
        default: () => {},
      },
      reportCustomization: {
        type: Object,
        default: () => {},
      },
      commonLang: {
        type: String,
        default: 'zh'
      }
    });

const PAGE_TEXT = {
  'zh': {
    tourismProjects: '旅游游乐项目 共',
    unitStore: '家',
    nearestProjects: '距离调研地最近的旅游游乐项目（最多展示各 TOP 5）',
    noTourismCoverage: '当前区域暂无旅游游乐项目覆盖',
    moreInfo: '>当前图表中仅展示部分分类，全部旅游数据于APP「周边配套」中查看',
    projectDistribution: '区域旅游游乐项目数量分布（个）',
    dataSource: '数据来源：位置厂商地图数据',
    type: '类型',
    nearestProject: '距离项目最近旅游游乐项目'
  },
  'en': {
    tourismProjects: 'Tourism & Entertainment Projects Total',
    unitStore: 'stores',
    nearestProjects: 'Nearest Tourism & Entertainment Projects (Top 5 Maximum for Each)',
    noTourismCoverage: 'No tourism & entertainment project coverage in current area',
    moreInfo: '',
    projectDistribution: 'Regional Tourism & Entertainment Project Quantity Distribution (pieces)',
    dataSource: 'Data Source: Location vendor map data',
    type: 'Type',
    nearestProject: 'Nearest Tourism & Entertainment Project to Project'
  }
};

      const color = [
        "#0045FF",
        "#FF7800",
        '#FF0000',
        '#17C49D',
        '#00BEFF',
        '#A933E4',
        '#00FF19',
        '#DACE10',
        '#6694CF',
        '#F53A99',
        '#A1C607',
        '#6005B1',
        '#FF5E87',
      ];
      const store = useStore()
      const colData = computed(() => [
          { prop: "name", width: "147px", label: PAGE_TEXT[props.commonLang].type },
          { prop: "names", width: "750px", label: PAGE_TEXT[props.commonLang].nearestProject },
      ]);
      const rowData = computed(() => {
        return props.catData.map(el => {
          return {
            name: el.bhProTypeName,
            names: el.poi.slice(0,5).map(el => el.name).join('、'),
            value: el?.count || 0,
            poi: el.poi || []
          }
        })
      });

      // poi改版
      const totalSize = computed(() => {
        if (!props.poiData || !props.poiData?.nearby?.length) return 0
        const item = props.poiData.nearby.find((n) => n.bhProType === 'P110000')
        return item?.count || 0
      })

      let map = shallowRef(null);
      const addMaker = (amap, map, data, color) => {
        let markerList = [];
        data.forEach((v) => {
          let marker = new amap.Marker({
            position: new amap.LngLat(
              v.location.split(",")[0],
              v.location.split(",")[1]
            ),
            content: `<div style="width: 12px;height: 12px; border-radius: 50%;background: ${color};"></div>`

          });
          markerList.push(marker);
        });
        map.add(markerList);
      };
      onMounted(() => {
        AMapLoader.load({
            key: AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then((AMap) => {
          map = new AMap.Map("page15Map", {
            WebGLParams: {
                preserveDrawingBuffer:true
            },
            dragEnable: false,
            zoomEnable: false,
            zoom: store.getters.mapZoom, //初始化地图级别
            center: props.cityInfo.location.split(","), //初始化地图中心点位置
          });

          for (let i = 0; i < rowData.value.length; i++) {
            addMaker(AMap, map, rowData.value[i]?.poi || [], color[i])
          }

          if (props.cityInfo.is_polygon) {
            mapAddPolygonV2(props.cityInfo?.polygon || '', map)
          } else {
            mapAddCircle(props.cityInfo, map);
          }
          addMapCenter(AMap, map, props.cityInfo.location)

          // 等待地图渲染
          const totalCount = rowData.value.reduce((a, b) => a + (b?.poi?.length || 0), 0)
          const delay = getMapDelayByMarkerCount(totalCount)
          drawMapKeepAlive(delay).catch((e) => {})

          map.setFitView()
        })
        .catch((e) => {
            console.log(e);
        });
      });

      const typeList = props.catData.map((item, index) => ({
        name: item.bhProTypeName,
        color: color[index],
      }))
</script>

<style lang="less">
.page20 {
    position: relative;
    background: #ffffff;
    padding: 26px 60px 32px 0;
  .page16-map-tips {
    flex-shrink: 0;
    text-align: right;
    height: 28px;
    font-size: 20px;
    font-weight: 400;
    color: #9a9a9a;
    line-height: 28px;
  }
    .page20-body {
        flex-grow: 1;
        padding: 67px 20px 0 61px;
        td {
            height: 50px;
            font-size: 18px;
            padding: 0 10px;
        }
        td:nth-child(2) {
            text-align: left;
        }
        .page20-body-left {
            width: 900px;
            .page20-body-header {
                height: 33px;
                font-size: 24px;

                font-weight: bold;
                color: #333333;
                line-height: 33px;
                margin-bottom: 10px;
            }
        }
        .page20-body-right {
            width: 853px;
            .page15-map {
                width: 100%;
                height: 760px;
            }
            .page15-map-legend {
                flex-grow: 1;
                padding: 23px 0 23px 46px;
                .page15-map-legend-item {
                    font-size: 20px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 28px;
                    margin-right: 56px;
                }
                .page15-map-legend-item:last-child {
                    margin-right: 0;
                }
                .page15-map-legend-icon {
                    width: 22px;
                    height: 22px;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    margin-right: 12px;
                }
                .icon1 {
                    background-image: url("~@/assets/机场.png");
                }
                .icon2 {
                    background-image: url("~@/assets/火车站.png");
                }
                .icon3 {
                    background-image: url("~@/assets/高铁站.png");
                }
                .page15-map-legend-point {
                    width: 22px;
                    height: 22px;
                    margin-right: 12px;
                    border-radius: 50%;
                }
                .point1 {
                    background-color: #1644ff;
                }
            }
            .page15-map-tips {
                flex-shrink: 0;
                text-align: right;
                height: 28px;
                font-size: 20px;
                font-weight: 400;
                color: #9a9a9a;
                line-height: 28px;
            }
        }
    }
}
</style>
